module.exports = __webpack_public_path__ + "img/Streak.5ad956c1.svg";